module.exports = __webpack_public_path__ + "static/img/award5_a.ff5b677.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/index/award5_a.png
// module id = unSW
// module chunks = 7